module.exports = __webpack_public_path__ + "static/media/image_56.360ef66f.png";